import api from './axios';

// Master Data API (Sample Names, Water Sources, Location Types, States/Districts)
export const masterDataAPI = {
  // Sample Names (e.g., Drinking Water, Waste Water, Pond Water, River Water)
  getSampleNames: (includeInactive = false) =>
    api.get('/master-data/sample-names', { params: { includeInactive } }),
  createSampleName: (data) => api.post('/master-data/sample-names', data),
  updateSampleName: (id, data) => api.patch(`/master-data/sample-names/${id}`, data),
  deleteSampleName: (id) => api.delete(`/master-data/sample-names/${id}`),

  // Water Sources
  getWaterSources: (includeInactive = false) =>
    api.get('/master-data/water-sources', { params: { includeInactive } }),
  createWaterSource: (data) => api.post('/master-data/water-sources', data),
  updateWaterSource: (id, data) => api.patch(`/master-data/water-sources/${id}`, data),
  deleteWaterSource: (id) => api.delete(`/master-data/water-sources/${id}`),

  // Location Types
  getLocationTypes: (includeInactive = false) =>
    api.get('/master-data/location-types', { params: { includeInactive } }),
  createLocationType: (data) => api.post('/master-data/location-types', data),
  updateLocationType: (id, data) => api.patch(`/master-data/location-types/${id}`, data),
  deleteLocationType: (id) => api.delete(`/master-data/location-types/${id}`),

  // States
  getStates: (includeInactive = false) =>
    api.get('/master-data/states', { params: { includeInactive } }),
  createState: (data) => api.post('/master-data/states', data),
  updateState: (id, data) => api.patch(`/master-data/states/${id}`, data),
  deleteState: (id) => api.delete(`/master-data/states/${id}`),

  // Districts
  getDistricts: (stateId, includeInactive = false) =>
    api.get(`/master-data/states/${stateId}/districts`, { params: { includeInactive } }),
  addDistrict: (stateId, data) => api.post(`/master-data/states/${stateId}/districts`, data),
  updateDistrict: (stateId, districtId, data) =>
    api.patch(`/master-data/states/${stateId}/districts/${districtId}`, data),
  deleteDistrict: (stateId, districtId) =>
    api.delete(`/master-data/states/${stateId}/districts/${districtId}`),

  // Seed default data
  seedData: () => api.post('/master-data/seed')
};

export default masterDataAPI;
